// extracted by mini-css-extract-plugin
module.exports = {"offersContainer":"Offers_offersContainer__1tY1U","controlsContainer":"Offers_controlsContainer__1Oo1d"};